var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M45.7423 24.4652C45.7423 22.7385 45.5993 21.4785 45.2899 20.1719H25.1709V27.9651H36.9803C36.7423 29.9018 35.4566 32.8185 32.5994 34.7784L32.5593 35.0393L38.9206 39.8688L39.3613 39.9119C43.4088 36.2485 45.7423 30.8585 45.7423 24.4652Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M25.1691 44.9992C30.9547 44.9992 35.8118 43.1324 39.3595 39.9125L32.5976 34.779C30.7881 36.0156 28.3595 36.879 25.1691 36.879C19.5026 36.879 14.6931 33.2157 12.9787 28.1523L12.7274 28.1733L6.11287 33.19L6.02637 33.4256C9.55012 40.2857 16.7882 44.9992 25.1691 44.9992Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M12.9811 28.1549C12.5288 26.8483 12.267 25.4482 12.267 24.0016C12.267 22.5548 12.5288 21.1549 12.9573 19.8482L12.9453 19.5699L6.24794 14.4727L6.02881 14.5748C4.5765 17.4215 3.74316 20.6182 3.74316 24.0016C3.74316 27.3849 4.5765 30.5814 6.02881 33.4282L12.9811 28.1549Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M25.1693 11.1199C29.193 11.1199 31.9072 12.8233 33.4549 14.2467L39.5025 8.46C35.7883 5.07668 30.9549 3 25.1693 3C16.7882 3 9.55014 7.7133 6.02637 14.5732L12.9549 19.8466C14.6932 14.7833 19.5026 11.1199 25.1693 11.1199Z",
    fill: "#EB4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon_google.060ca17c4f31dc9c5e46a95cef1f0e14.svg";
export { ForwardRef as ReactComponent };